import React from "react";
import classes from "../Management.module.scss";
import styles from "./DealerPipeline.module.scss";

/**
 * A customer's name that opens their page (CustomerPanel). Plain text when
 * there's no ref or nowhere to open it.
 *
 * Props: customer (a ref from customerRefOf), onOpen(ref), children
 */
const CustomerLink = ({ customer, onOpen, children }) => (customer && onOpen ? (
  <button
    type="button"
    className={`${classes.clickableCell} ${styles.linkButton}`}
    title="Open the customer"
    onClick={() => onOpen(customer)}
  >
    {children}
  </button>
) : <>{children}</>);

export default CustomerLink;
